/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, Fragment } from "react";
import { Table } from "react-bootstrap";
import PropTypes from "prop-types";
import { useAxios } from "utils/CustomHooks";
import { Pagination, ResponseHandler } from "components";
import { useHistory } from "react-router-dom";
import "./kitchenOrdinaryTableList.scss";
import { ReactComponent as BlueShow } from "assets/icons/‌Blue_Show.svg";

const KitchenOrdinaryTableList = ({
    columns,
    url,
    filterParams,
    orderType,
    isDry = false,
}) => {
    const [fetchData, setFetchParams] = useAxios();

    useEffect(() => {
        setFetchParams({
            method: "get",
            url: url,
            params: filterParams,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterParams]);

    const {
        response: records,
        loading: recordsLoading,
        error,
    } = url ? fetchData : { response: null, loading: false, error: false };

    const tableData = records && records.data;

    useEffect(() => {
        localStorage.setItem("receivingOrderType", JSON.stringify(orderType));
    }, [orderType]);

    const style = {
        1: "not-delivered",
        2: "without-delay",
        3: "has-delay",
    };
    return (
        <ResponseHandler
            loading={recordsLoading}
            response={tableData?.length}
            error={error}
        >
            <div className="page-template-table-container">
                <Table bordered hover className={`kitchen-list-container rtl`}>
                    <thead>
                        <tr>
                            {columns.map((item) => (
                                <th key={item.id}>{item.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData &&
                            tableData.map((item) => {
                                return (
                                    <tr
                                        className="receiving-container"
                                        style={{
                                            cursor: `${item.orderless ? "default" : "pointer"}`,
                                            backgroundColor: item.has_receiving
                                                ? "#d4ccb8"
                                                : "inherit",
                                        }}
                                        key={item.uid}
                                    >
                                        <td>
                                            <a
                                                className={`receiving-link-style ${item.orderless ? "order-less" : ""}`}
                                                href={
                                                    isDry
                                                        ? `/dry-receiving-detail/${item.dep_receiving_id}`
                                                        : !item.orderless ===
                                                            true
                                                          ? `/${"receiving-daily-detail"}/${item.id}/${item.hub_id}`
                                                          : "#"
                                                }
                                                // onClick={() =>
                                                //     localStorage.setItem(
                                                //         "receivingOrderType",
                                                //         JSON.stringify(
                                                //             orderType
                                                //         )
                                                //     )
                                                // }
                                            >
                                                <Fragment>
                                                    {item.vendor_title}{" "}
                                                    {!!item.orderless && (
                                                        <span className="title-orderless">
                                                            {isDry
                                                                ? "بدون سفارش برای روز دریافت"
                                                                : "بدون سفارش"}
                                                        </span>
                                                    )}
                                                </Fragment>
                                            </a>
                                        </td>
                                        <td>
                                            <a
                                                href={
                                                    isDry
                                                        ? `/dry-receiving-detail/${item.dep_receiving_id}`
                                                        : !item.orderless ===
                                                            true
                                                          ? `/${"receiving-daily-detail"}/${item.id}/${item.hub_id}`
                                                          : "#"
                                                }
                                                // onClick={() =>
                                                //     localStorage.setItem(
                                                //         "receivingOrderType",
                                                //         JSON.stringify(
                                                //             orderType
                                                //         )
                                                //     )
                                                // }
                                            >
                                                {item.date_str}
                                            </a>
                                        </td>
                                        <td>
                                            <a
                                                href={
                                                    isDry
                                                        ? `/dry-receiving-detail/${item.dep_receiving_id}`
                                                        : !item.orderless ===
                                                            true
                                                          ? `/${"receiving-daily-detail"}/${item.id}/${item.hub_id}`
                                                          : "#"
                                                }
                                                // onClick={() =>
                                                //     localStorage.setItem(
                                                //         "receivingOrderType",
                                                //         JSON.stringify(
                                                //             orderType
                                                //         )
                                                //     )
                                                // }
                                            >
                                                {item.hub_title}
                                            </a>
                                        </td>
                                        <td>
                                            <a
                                                href={
                                                    isDry
                                                        ? `/dry-receiving-detail/${item.dep_receiving_id}`
                                                        : !item.orderless ===
                                                            true
                                                          ? `/${"receiving-daily-detail"}/${item.id}/${item.hub_id}`
                                                          : "#"
                                                }
                                                // onClick={() =>
                                                //     localStorage.setItem(
                                                //         "receivingOrderType",
                                                //         JSON.stringify(
                                                //             orderType
                                                //         )
                                                //     )
                                                // }
                                            >
                                                {item.type_str}
                                            </a>
                                        </td>
                                        {/* <td>
                                            <a
                                                href={`${!item.orderless === true ? `/receiving-detail/${item.id}/${item.hub_id}` : "#"}`}
                                            >
                                                {item.type_str}
                                            </a>
                                        </td> */}
                                        {/* <td>
                                            <a
                                                href={`${!item.orderless === true ? `/receiving-detail/${item.id}/${item.hub_id}` : "#"}`}
                                            >
                                                {item.type_str}
                                            </a>
                                        </td> */}
                                        {/* <td>
                                            <a
                                                href={`${!item.orderless === true ? `/receiving-detail/${item.id}/${item.hub_id}` : "#"}`}
                                            >
                                                {item.type_str}
                                            </a>
                                        </td> */}
                                        <td>
                                            <a
                                                className={
                                                    style[
                                                        item?.arrival_status ||
                                                            1
                                                    ]
                                                }
                                                href={`${!item.orderless === true ? (isDry ? `/dry-receiving-detail/${item.dep_receiving_id}` : `/${"receiving-daily-detail"}/${item.id}/${item.hub_id}`) : "#"}`}
                                            >
                                                {item?.arrival_status_str || ""}
                                            </a>
                                        </td>
                                        <td className="view-icon-receiving">
                                            {item?.file_name ? (
                                                <a
                                                    onClick={(e) =>
                                                        e.stopPropagation()
                                                    }
                                                    href={`/receiving-upload-image?imageUrl=${encodeURIComponent(item?.file_name)}`}
                                                >
                                                    <BlueShow />
                                                </a>
                                            ) : (
                                                <div>-</div>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </Table>
                <Pagination
                    totalCount={records?.total}
                    pageSize={records?.per_page}
                    currentPage={records?.current_page}
                    onPageChange={(currentPage) =>
                        setFetchParams({
                            method: "get",
                            url: `${url}?page=${currentPage}&pagesize=${records?.per_page}`,
                            params: filterParams,
                        })
                    }
                />
            </div>
        </ResponseHandler>
    );
};

KitchenOrdinaryTableList.propTypes = {
    pageName: PropTypes.string,
    url: PropTypes.string,
    fetchNewList: PropTypes.bool,
    rowLinkUrl: PropTypes.string,
    emptyText: PropTypes.string,
};

export default KitchenOrdinaryTableList;
